<template>
  <div
    :class="noMargin?'mb-0':''"
    class="form-group position-relative">
    <label
      v-if="label"
      :for="id">
      <IconCulture v-if="localizable" />
      {{ label }}
    </label>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      default: null,
    },
    localizable: {
      type: Boolean,
      default: false,
    },
    noMargin: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  font-weight: 600;
}
</style>
